'use client'

import { useEffect, useState } from 'react'

export default function ShareWhatsapp({
  children,
  url,
  title,
  className,
}: {
  children?: React.ReactNode
  url?: string
  title?: string
  className?: string
}) {
  const [shareUrl, setShareUrl] = useState<string>(url || '')

  useEffect(() => {
    if (!shareUrl) {
      const currentUrl = window.location.href
      setShareUrl(currentUrl)
    }
  }, [shareUrl])

  return (
    <a
      href={`https://api.whatsapp.com/send?text=${encodeURIComponent(title || '')} ${encodeURIComponent(shareUrl)}`}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      aria-label='Share on WhatsApp'
    >
      {children}
    </a>
  )
}
